export default {
  vision: "vision".toUpperCase(),
  thats_the_vision: "That's the Vision".toUpperCase(),
  all_rights__: "2025 VISION. All rights reserved.",
};
